<template>
  <div class="error">
    <div class="error__left">
      <p class="error__icon" data-title="ERROR">
        <span>ERROR</span>
      </p>
    </div>

    <div class="error__right">
      <p class="error__text">{{ $t('error.message.ieNotSupported') }}</p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
